import * as SeparatorPrimitive from '@radix-ui/react-separator';
import { ComponentProps } from 'react';
import { cn } from '../../utils/cn';

type SeparatorProps = ComponentProps<typeof SeparatorPrimitive.Root>;

export const Separator = ({ className, orientation = 'horizontal', decorative = true, ...props }: SeparatorProps) => {
  return (
    <SeparatorPrimitive.Root
      data-slot="separator"
      decorative={decorative}
      orientation={orientation}
      className={cn(
        'shrink-0 bg-border data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px',
        className,
      )}
      {...props}
    />
  );
};
